import { Category } from '@smg-real-estate/hg-rets-schema';

export function isCommercialObject(listingCategories: Category[]): boolean {
  const commercialCategories = [
    Category.Office,
    Category.Retail,
    Category.Factory,
    Category.RetailSpace,
    Category.ResidentialCommercialBuilding,
    Category.Hospital,
    Category.MiniGolfCourse,
    Category.NursingHome,
    Category.RidingHall,
    Category.Sanatorium,
    Category.Workshop,
    Category.PartyRoom,
    Category.Sauna,
    Category.Solarium,
    Category.OldAgeHome,
    Category.Institution,
    Category.DisplayWindow,
    Category.ParkingSpace,
    Category.CarPark,
  ];
  return !!listingCategories?.some((category) => commercialCategories.includes(category));
}
